
define('ui-helper/storage-helper',['jquery', 'knockout'], function($, ko) {
    var Stores = {
        LOCAL_STORAGE: "localStorage",
        SESSION_STORAGE: "sessionStorage"
    };
    var STORAGE_KEY = {
        CLIENT_ID: "clientId"
    };

    function isSafari() {
        try {
            var ua = navigator.userAgent.toLowerCase();
            return ua.indexOf('safari') > -1 &&
                   ua.indexOf('chrome') === -1 &&
                   ua.indexOf('chromium') === -1 &&
                   ua.indexOf('android') === -1;
        } catch (e) {
            return false;
        }
    }
    function isStorageAvailable(params) {
        var webStorageType = params.webStorageType;
        if (typeof window === "undefined" || !window[webStorageType]) {
            return false;
        }
        return true;
    }
    function isStorageSupported(params) {
        if (!isStorageAvailable(params)) {
            return false;
        }
        var webStorageType = params.webStorageType;
        var storage = window[webStorageType];
        try {
            var temporaryData = '__storage_test__';
            storage.setItem(temporaryData, temporaryData);
            storage.removeItem(temporaryData);
            return true;
        } catch (err) {
            return false;
        }
    }
    function getItem(params) {
        if (!isStorageAvailable(params)) {
            return null;
        }
        var key = params.key;
        var webStorageType = params.webStorageType;
        var item = key && window[webStorageType].getItem(key);
        return item;
    }
    function getClientId() {
        return STORAGE_KEY.CLIENT_ID + " " + getItem({
            key: STORAGE_KEY.CLIENT_ID,
            webStorageType: Stores.LOCAL_STORAGE
        });
    }
    function setItem(params) {
        var key = params.key;
        var value = params.value;
        var webStorageType = params.webStorageType;
        if (!isStorageSupported({webStorageType: webStorageType})) {
            console.error(webStorageType + " API is not supported. key: " + key);
            return;
        }
        try {
            if (key) {
                window[webStorageType].setItem(key, value);
            }
        } catch (err) {
            console.error(getClientId() + ", key: " + key + ". " + webStorageType + " is full.", err);
        }
    }
    function removeItem(params) {
        var key = params.key;
        var webStorageType = params.webStorageType;
        if (isStorageAvailable({webStorageType: webStorageType})) {
            if (key) {
                // Safari-specific workaround for both localStorage and sessionStorage
                if (isSafari() && typeof window !== 'undefined') {
                    try {
                        if (webStorageType === Stores.SESSION_STORAGE && window.sessionStorage) {
                            window.sessionStorage.removeItem(key);
                        } else if (webStorageType === Stores.LOCAL_STORAGE && window.localStorage) {
                            window.localStorage.removeItem(key);
                        }
                    } catch (e) {
                        // Silently handle any Safari-specific errors
                    }
                }else{
                    window[webStorageType].removeItem(key);
                }
            }
        }
    }
    function clearAll(params) {
        var webStorageType = params.webStorageType;
        if (isStorageAvailable({webStorageType: webStorageType})) {
            window[webStorageType].clear();
        }
    }

    return {
        getItem: getItem,
        setItem: setItem,
        removeItem: removeItem,
        clearAll: clearAll,
        Stores: Stores
    };
});